import React from 'react';

export type OrganizationRegistryValues = {
  vatId: string;
  taxNumber: string;
  commercialRegisterNumber: string;
};

export function OrganizationRegistryFields({
  values,
  onChange,
  labelClass,
  inputClass,
  fieldWrapClass,
}: {
  values: OrganizationRegistryValues;
  onChange: (patch: Partial<OrganizationRegistryValues>) => void;
  labelClass: string;
  inputClass: string;
  fieldWrapClass: string;
}) {
  return (
    <>
      <div className={fieldWrapClass}>
        <label className={labelClass}>USt-IdNr.</label>
        <input
          type="text"
          value={values.vatId}
          onChange={(e) => onChange({ vatId: e.target.value })}
          className={inputClass}
          placeholder="DE123456789"
          autoComplete="off"
        />
      </div>
      <div className={fieldWrapClass}>
        <label className={labelClass}>Steuernummer</label>
        <input
          type="text"
          value={values.taxNumber}
          onChange={(e) => onChange({ taxNumber: e.target.value })}
          className={inputClass}
          placeholder="z. B. 12/123/12345"
          autoComplete="off"
        />
      </div>
      <div className={fieldWrapClass}>
        <label className={labelClass}>Handelsregisternr.</label>
        <input
          type="text"
          value={values.commercialRegisterNumber}
          onChange={(e) => onChange({ commercialRegisterNumber: e.target.value })}
          className={inputClass}
          placeholder="z. B. HRB 12345"
          autoComplete="off"
        />
      </div>
    </>
  );
}

export function organizationRegistryPayload(values: OrganizationRegistryValues) {
  return {
    vat_id: values.vatId.trim() || undefined,
    tax_number: values.taxNumber.trim() || undefined,
    commercial_register_number: values.commercialRegisterNumber.trim() || undefined,
  };
}
